/* src/app/shared/components/form-errors/form-errors.component.scss */
.error__key {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  color: #DF2901;
  font-weight: 600;
  margin: 0;
}
.error__key [class^=material-symbols-] {
  font-size: 1.5em;
}
.error__messages {
  margin: 0 0 1em 0;
  padding: 0 1.75em;
  line-height: 1;
}
.error__message {
  color: #991C00;
}
:host(.form-errors) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: auto;
  font-size: 0.75em;
}
/*# sourceMappingURL=form-errors.component.css.map */
